"use client";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  endSession,
  installSessionGuard,
  storedSession,
  tokenExpired,
} from "@/utility/session";

// Mounted once in the root layout: every 401 from our API ends the session, and a
// stored login whose token already expired is ended before anything uses it.
const SessionGuard = () => {
  const { t } = useTranslation();

  useEffect(() => {
    installSessionGuard();
    const session = storedSession();
    if (session && tokenExpired(session.token)) {
      endSession();
      return;
    }
    if (new URLSearchParams(window.location.search).get("expired")) {
      toast.info(
        t("session_expired_login_again", {
          defaultValue: "Your session has expired. Please log in again.",
        })
      );
    }
  }, []);

  return null;
};

export default SessionGuard;
